class FormStepHeaderOption {
    constructor(route, name, icon) {
        this.route = route
        this.name = name
        this.icon = icon
    }

    static fromJson({ route, name, icon }) {
        return new FormStepHeaderOption(route, name, icon)
    }
}

export default FormStepHeaderOption
